<template>
  <div class="filter-panel-ctnr">
    <div class="filter-panel-wrp">
      <div class="left">
        <div class="title-col">
          <filter-icon filter="none" class="filter-icon"></filter-icon>

          <div class="title-text">筛选</div>
        </div>
        <div class="form-col">
          <div class="input-value">
            <el-checkbox
              @change="onFilter"
              :disabled="layout.showLoading"
              v-model="form.spaceActive"
              >{{ $t("message.spotyunjia.xiancang") }}</el-checkbox
            >
          </div>
          <div class="input-value">
            <el-checkbox
              :disabled="layout.showLoading"
              v-model="form.dirActive"
              @change="onFilter"
              >直达</el-checkbox
            >
          </div>
          <div class="input-value input-value--select">
            <el-select
              @change="onFilter"
              multiple
              collapse-tags
              :disabled="layout.showLoading"
              class="select-input"
              v-model="form.shippings"
              :placeholder="'船公司'"
              clearable
            >
              <el-option
                v-for="item in filterShippingList"
                :key="item.name"
                :label="item.showName"
                :value="item.name"
              ></el-option>
            </el-select>
          </div>
          <div class="input-value">
            <el-date-picker
              @change="onFilter"
              :disabled="layout.showLoading"
              v-model="form.etdRange"
              type="daterange"
              :range-separator="'--'"
              start-placeholder="ETD"
              end-placeholder=""
              :clearable="true"
              format="yyyy-MM-dd"
              value-format="timestamp"
              class="date-range-controller"
            >
            </el-date-picker>
          </div>
        </div>
      </div>
      <div class="right">
        <div
          class="order-list"
          :class="layout.showLoading ? 'order-list--disabled' : ''"
        >
          <div
            class="order-item"
            :class="form.order === 1 ? 'order-item--active' : ''"
            @click="orderTap(1)"
          >
            {{ $t("message.spotyunjia.zuizao") }}
          </div>
          <div
            class="order-item"
            :class="form.order === 2 ? 'order-item--active' : ''"
            @click="orderTap(2)"
          >
            {{ $t("message.spotyunjia.zuikuai") }}
          </div>
          <div
            class="order-item"
            :class="form.order === 3 ? 'order-item--active' : ''"
            @click="orderTap(3)"
          >
            {{ $t("message.spotyunjia.zuipianyi") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { shippingOptions } from "../../api/option";
export default {
  props: {
    layout: {
      type: Object,
      default: () => ({}),
    },
    filterShippingList: {
      type: Array,
      default: () => [],
    },
  },

  components: {},
  data() {
    return {
      shippingOptions,
      form: {
        spaceActive: false,
        dirActive: false,
        shippings: [],
        etdRange: [],
        order: "",
      },
    };
  },
  created() {},
  mounted() {},
  methods: {
    reset() {
      this.form = {
        spaceActive: false,
        dirActive: false,
        shippings: [],
        etdRange: [],
        order: "",
      };
    },
    onFilter() {
      console.log("==========on filter");
      this.$emit("filter");
    },
    orderTap(order) {
      if (this.layout.showLoading) return;
      if (this.form.order === order) {
        this.form.order = "";
      } else {
        this.form.order = order;
      }
      this.$emit("filter");
    },
    GetParams() {
      return { ...this.form };
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../../../styles//tool.scss";
.filter-panel-ctnr {
  margin-top: 16px;
  .filter-panel-wrp {
    margin: auto;

    width: 1200px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 12px;
    background: #fff;
    box-shadow: 1px 1px 20px 0 rgba(105, 126, 157, 0.1);
    border-radius: 10px 10px 0 0;
    margin: 0 auto 6px;

    .left {
      display: flex;
      align-items: center;

      .title-col {
        display: flex;
        align-items: center;
        flex: 0 0 auto;
        .filter-icon {
          flex: 0 0 auto;
          margin-right: 10px;
        }
        .title-text {
          flex: 0 0 auto;
          font-size: 16px;
          font-weight: bold;
          color: #242933;
        }
      }
      /deep/ .form-col {
        display: flex;
        align-items: center;
        .input-value {
          margin-left: 10px;
          .select-input {
            // width: 114px;
          }

          .date-range-controller {
            width: 300px;
            .el-range-input {
              font-size: 14px;
            }
            .el-range-separator {
              font-size: 14px;
              white-space: nowrap;
              position: relative;
              bottom: -2px;
            }
            i {
              position: relative;
              bottom: -2px;
            }
          }
          .el-input__inner {
            font-size: 14px;
            height: 34px !important;
            padding-left: 10px !important;
          }
        }
        .input-value--select {
          @include refactorElInputWidget();
          .el-input .el-select__caret.is-reverse {
            color: var(--theme) !important;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .el-select {
            .el-input {
              &.is-disabled {
                .el-input__inner {
                  background-color: #f5f7fa;
                  border-color: #e4e7ed;
                  color: #c0c4cc;
                }
              }
            }
          }
        }
      }
    }
    .right {
      .order-list {
        display: flex;
        align-items: center;
        .order-item {
          font-size: 14px;
          font-weight: 500;
          color: #444755;
          line-height: 28px;
          padding: 0 11px;
          transition: all 0.35s;
          cursor: pointer;
          margin-left: 16px;
          border-radius: 6px;
          &:first-child {
            margin-left: 0;
          }
          &:hover {
            color: var(--theme);
          }
          &.order-item--active {
            background: rgba(var(--theme-rgb), 0.1);
            color: var(--theme);
          }
        }
        &.order-list--disabled {
          .order-item {
            cursor: not-allowed;
            opacity: 0.5;
            &:hover {
              color: #444755;
            }
          }
        }
      }
    }
  }
}
</style>
